import { useContext, useEffect, useState } from "react";
import { STEPS } from "../App";
import { AppContext } from "../App.context";
import { Question } from "../components/Question";

export const QuestionsStep = () => {
  const { changeStep, questionsGenerator, questionsCount } = useContext(
    AppContext
  );
  const [currentQuestion, setCurrentQuestion] = useState(null);

  useEffect(() => {
    if (!questionsGenerator) return;
    setCurrentQuestion(questionsGenerator.next().value);
  }, [questionsGenerator]);

  const handleNextQuestion = () => {
    const nextQuestion = questionsGenerator.next();
    if (nextQuestion.done) {
      changeStep(STEPS.SUMMARY);
    }
    setCurrentQuestion(nextQuestion.value);
  };

  if (!currentQuestion) return null;
  return (
    <div>
      <h2 style={{ textAlign: "center" }}>
        Pytanie {`${currentQuestion.index} / ${questionsCount}`}
      </h2>
      <Question {...currentQuestion} onNext={handleNextQuestion} />
    </div>
  );
};
